// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "Documents" + "." + "9f1b71ad" + ".chunk.css";
};